// extracted by mini-css-extract-plugin
module.exports = {"listDivider":"list-divider-module__listDivider___1xhxg"};